<template>
  <div>
    <e-tabs :list="this.$constant.tabListStockOut()" isJump />
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped></style>
